import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../Common/Layout/CustomAlerts";
import Header from "../Common/Layout/Header";
import SideBar from "../Common/Layout/Sidebar";

const initialFieldValues = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
};
export default function ChangePassword() {
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json",
        },
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    const validate = () => {
        let temp = {};
        temp.oldPassword = values.oldPassword === "" ? false : true;
        temp.newPassword = values.newPassword === "" ? false : true;
        temp.confirmNewPassword =
            values.confirmNewPassword === ""
                ? false
                : values.confirmNewPassword === values.newPassword;

        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            const userId = localStorage.getItem("userId");
            const formData = {
                userId: userId,
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            };
            changePassword(formData);
        }
    };
    const applicationAPI = () => {
        return {
            changePassword: (newPasswordData) => {
                const { userId, oldPassword, newPassword } = newPasswordData;
                const url = config.APIACTIVATEURL + config.CHANGEPASSWORD +
                    "?UserId=" + userId +
                    "&OldPassword=" + oldPassword +
                    "&NewPassword=" + newPassword;

                return axios.post(url, null, { ...headerconfig });
            },
        };
    };

    const changePassword = (formData) => {
        applicationAPI()
            .changePassword(formData)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    handleSuccess(res.data.data);
                    resetForm();
                } else {
                    handleError(res.data.data);
                }
            })
            .catch((error) => {
                handleError("Error changing password");
            });
    };
    const resetForm = () => {
        setValues(initialFieldValues);
    };

    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";

    useEffect(() => {

    }, []);
    return (
        <div className="card">
            <div className="card-header bg-soft-danger">
                <h5 className="text-black mb-0">Change Password</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-lg-12 mb-3">
                        <label className="lh-1 text-16 text-light-1"> Old password</label>
                        <input type="text" name="oldPassword" value={values.oldPassword} onChange={handleInputChange}
                            className={"form-control" + applyErrorClass("oldPassword")} placeholder="Old Password" required />
                        {errors.oldPassword === false ? (<div style={{ color: "red" }} className="validationerror"> Please enter old password</div>) : ("")}
                    </div>
                    {/* end col */}
                    <div className="col-12 mb-3">
                        <label className="lh-1 text-16 text-light-1">
                            New password
                        </label>
                        <input
                            type="text"
                            name="newPassword"
                            value={values.newPassword}
                            onChange={handleInputChange}
                            className={
                                "form-control" + applyErrorClass("newPassword")
                            }
                            placeholder="New Password"
                            required
                        />
                        {errors.newPassword === false ? (
                            <div style={{ color: "red" }} className="validationerror">
                                Please enter new password
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className="col-12 mb-3">
                        <label className="lh-1 text-16 text-light-1">
                            Confirm new password
                        </label>
                        <input
                            type="password"
                            name="confirmNewPassword"
                            value={values.confirmNewPassword}
                            onChange={handleInputChange}
                            className={
                                "form-control" + applyErrorClass("confirmNewPassword")
                            }
                            placeholder="Confirm New Password"
                            required
                        />
                        {errors.confirmNewPassword === false ? (
                            <div style={{ color: "red" }} className="validationerror">
                                Please enter confirm password
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className="col-lg-12">
                        <div className="text-end">
                            <button type="button" className="btn btn-info" onClick={handleSubmit}>
                                Change Password
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* end card-body */}
        </div>
    );
} 